import { render, staticRenderFns } from "./SetupOverviewAppliance.vue?vue&type=template&id=dbe921bc&scoped=true"
import script from "./SetupOverviewAppliance.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewAppliance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe921bc",
  null
  
)

export default component.exports